import { render, staticRenderFns } from "./Predicates.vue?vue&type=template&id=021fd9b5&scoped=true&"
import script from "./Predicates.vue?vue&type=script&lang=js&"
export * from "./Predicates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021fd9b5",
  null
  
)

export default component.exports